import { Component, OnInit, Input } from '@angular/core';
import { GlobalsService } from '../globals.service';

@Component({
  selector: 'app-tools',
  templateUrl: './tools.component.html',
  styleUrls: ['./tools.component.scss']
})
export class ToolsComponent implements OnInit {

  @Input()
  live = true;
  position = 'after';

  constructor(
    public globals: GlobalsService,
  ) { }

  ngOnInit() {}

  resetTools() {
    this.globals.reset();
  }
}



// WEBPACK FOOTER //
// /Users/charles/Documents/AState-Senior/HCI/proj/amd2/src/app/tools/tools.component.ts